// Primary countries (top 5 clients)
export const PRIMARY_COUNTRIES = [
  { label: 'México', value: 'México', code: 'MX' },
  { label: 'Estados Unidos', value: 'Estados Unidos', code: 'US' },
  { label: 'Colombia', value: 'Colombia', code: 'CO' },
  { label: 'Chile', value: 'Chile', code: 'CL' },
  { label: 'España', value: 'España', code: 'ES' }
];

// Extended countries list (Latin America + common)
export const EXTENDED_COUNTRIES = [
  { label: 'Argentina', value: 'Argentina', code: 'AR' },
  { label: 'Bolivia', value: 'Bolivia', code: 'BO' },
  { label: 'Brasil', value: 'Brasil', code: 'BR' },
  { label: 'Costa Rica', value: 'Costa Rica', code: 'CR' },
  { label: 'Cuba', value: 'Cuba', code: 'CU' },
  { label: 'Ecuador', value: 'Ecuador', code: 'EC' },
  { label: 'El Salvador', value: 'El Salvador', code: 'SV' },
  { label: 'Guatemala', value: 'Guatemala', code: 'GT' },
  { label: 'Honduras', value: 'Honduras', code: 'HN' },
  { label: 'Nicaragua', value: 'Nicaragua', code: 'NI' },
  { label: 'Panamá', value: 'Panamá', code: 'PA' },
  { label: 'Paraguay', value: 'Paraguay', code: 'PY' },
  { label: 'Perú', value: 'Perú', code: 'PE' },
  { label: 'Puerto Rico', value: 'Puerto Rico', code: 'PR' },
  { label: 'República Dominicana', value: 'República Dominicana', code: 'DO' },
  { label: 'Uruguay', value: 'Uruguay', code: 'UY' },
  { label: 'Venezuela', value: 'Venezuela', code: 'VE' },
  { label: 'Alemania', value: 'Alemania', code: 'DE' },
  { label: 'Canadá', value: 'Canadá', code: 'CA' },
  { label: 'Francia', value: 'Francia', code: 'FR' },
  { label: 'Italia', value: 'Italia', code: 'IT' },
  { label: 'Portugal', value: 'Portugal', code: 'PT' },
  { label: 'Reino Unido', value: 'Reino Unido', code: 'GB' }
];

// Backwards compatibility: COUNTRY_OPTIONS = all countries combined
export const COUNTRY_OPTIONS = [...PRIMARY_COUNTRIES, ...EXTENDED_COUNTRIES];

export const COUNTRY_CODE_BY_NAME = COUNTRY_OPTIONS.reduce((acc, item) => {
  if (item.code) {
    acc[item.value] = item.code;
  }
  return acc;
}, {});

export const COUNTRY_STATE_OPTIONS = {
  CL: [
    'Arica y Parinacota',
    'Tarapacá',
    'Antofagasta',
    'Atacama',
    'Coquimbo',
    'Valparaíso',
    'Metropolitana de Santiago',
    "O'Higgins",
    'Maule',
    'Ñuble',
    'Biobío',
    'La Araucanía',
    'Los Ríos',
    'Los Lagos',
    'Aysén',
    'Magallanes y de la Antártica Chilena'
  ],
  CO: [
    'Amazonas',
    'Antioquia',
    'Arauca',
    'Atlántico',
    'Bolívar',
    'Boyacá',
    'Caldas',
    'Caquetá',
    'Casanare',
    'Cauca',
    'Cesar',
    'Chocó',
    'Córdoba',
    'Cundinamarca',
    'Guainía',
    'Guaviare',
    'Huila',
    'La Guajira',
    'Magdalena',
    'Meta',
    'Nariño',
    'Norte de Santander',
    'Putumayo',
    'Quindío',
    'Risaralda',
    'San Andrés y Providencia',
    'Santander',
    'Sucre',
    'Tolima',
    'Valle del Cauca',
    'Vaupés',
    'Vichada',
    'Bogotá D.C.'
  ]
};

export const COUNTRY_CITY_OPTIONS = {
  MX: {
    Aguascalientes: ['Aguascalientes'],
    'Baja California': ['Mexicali'],
    'Baja California Sur': ['La Paz'],
    Campeche: ['Campeche'],
    Chiapas: ['Tuxtla Gutiérrez'],
    Chihuahua: ['Chihuahua'],
    'Ciudad de México': ['Ciudad de México'],
    Coahuila: ['Saltillo'],
    Colima: ['Colima'],
    Durango: ['Durango'],
    Guanajuato: ['Guanajuato'],
    Guerrero: ['Chilpancingo de los Bravo'],
    Hidalgo: ['Pachuca de Soto'],
    Jalisco: ['Guadalajara'],
    México: ['Toluca de Lerdo'],
    Michoacán: ['Morelia'],
    Morelos: ['Cuernavaca'],
    Nayarit: ['Tepic'],
    'Nuevo León': ['Monterrey'],
    Oaxaca: ['Oaxaca de Juárez'],
    Puebla: ['Puebla'],
    Querétaro: ['Querétaro'],
    'Quintana Roo': ['Chetumal'],
    'San Luis Potosí': ['San Luis Potosí'],
    Sinaloa: ['Culiacán Rosales'],
    Sonora: ['Hermosillo'],
    Tabasco: ['Villahermosa'],
    Tamaulipas: ['Ciudad Victoria'],
    Tlaxcala: ['Tlaxcala'],
    Veracruz: ['Xalapa-Enríquez'],
    Yucatán: ['Mérida'],
    Zacatecas: ['Zacatecas']
  },
  CL: {
    'Arica y Parinacota': ['Arica'],
    Tarapacá: ['Iquique'],
    Antofagasta: ['Antofagasta'],
    Atacama: ['Copiapó'],
    Coquimbo: ['La Serena'],
    Valparaíso: ['Valparaíso'],
    'Metropolitana de Santiago': ['Santiago'],
    "O'Higgins": ['Rancagua'],
    Maule: ['Talca'],
    Ñuble: ['Chillán'],
    Biobío: ['Concepción'],
    'La Araucanía': ['Temuco'],
    'Los Ríos': ['Valdivia'],
    'Los Lagos': ['Puerto Montt'],
    Aysén: ['Coyhaique'],
    'Magallanes y de la Antártica Chilena': ['Punta Arenas']
  },
  CO: {
    Amazonas: ['Leticia'],
    Antioquia: ['Medellín'],
    Arauca: ['Arauca'],
    Atlántico: ['Barranquilla'],
    Bolívar: ['Cartagena'],
    Boyacá: ['Tunja'],
    Caldas: ['Manizales'],
    Caquetá: ['Florencia'],
    Casanare: ['Yopal'],
    Cauca: ['Popayán'],
    Cesar: ['Valledupar'],
    Chocó: ['Quibdó'],
    Córdoba: ['Montería'],
    Cundinamarca: ['Bogotá'],
    Guainía: ['Inírida'],
    Guaviare: ['San José del Guaviare'],
    Huila: ['Neiva'],
    'La Guajira': ['Riohacha'],
    Magdalena: ['Santa Marta'],
    Meta: ['Villavicencio'],
    Nariño: ['Pasto'],
    'Norte de Santander': ['Cúcuta'],
    Putumayo: ['Mocoa'],
    Quindío: ['Armenia'],
    Risaralda: ['Pereira'],
    'San Andrés y Providencia': ['San Andrés'],
    Santander: ['Bucaramanga'],
    Sucre: ['Sincelejo'],
    Tolima: ['Ibagué'],
    'Valle del Cauca': ['Cali'],
    Vaupés: ['Mitú'],
    Vichada: ['Puerto Carreño'],
    'Bogotá D.C.': ['Bogotá']
  }
};

export const getCountryCode = (countryName) => COUNTRY_CODE_BY_NAME[countryName] || null;

export const buildStateOptions = (states = []) =>
  states.map((state) => ({ value: state, label: state }));

export const getCityOptions = (countryCode, stateName) => {
  if (!countryCode || !stateName) return [];
  const countryCities = COUNTRY_CITY_OPTIONS[countryCode] || {};
  const cities = countryCities[stateName] || [];
  return cities.map((city) => ({ value: city, label: city }));
};
